import React, {Component} from "react";
import {connect} from "react-redux";
import {startLoader, register, registerError} from "../../data/actionCreators";
import {message, Spin} from "antd";
import {RegisterContainer} from "./RegisterContainer";
import {registerErrorMessage} from "../../helpers/error";

const mapStateToProps = (dataStore) => ({
    ...dataStore
});

const mapDispatchToProps = dispatch => ({
    register: (data, history, onSuccess) => {
        dispatch(startLoader());
        dispatch(register(data, (response)=> {
            if (response.data.id) {
                message.success('Formularz rejestracji został wysłany');
            }
            onSuccess();
            history.push('/login');
        }, (error) => {
            dispatch(registerError(error));
            registerErrorMessage(error);
        }));
    }
});

export const RegisterConnector = connect(mapStateToProps, mapDispatchToProps)(
    class extends Component {
        render() {
            return <Spin spinning={this.props.loading}>
                <RegisterContainer {...this.props}/>
            </Spin>
        }
    }
);
